import { render, staticRenderFns } from "./message-ai-card.vue?vue&type=template&id=679bf614&scoped=true"
import script from "./message-ai-card.vue?vue&type=script&lang=js"
export * from "./message-ai-card.vue?vue&type=script&lang=js"
import style0 from "./message-ai-card.vue?vue&type=style&index=0&id=679bf614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679bf614",
  null
  
)

export default component.exports